// extracted by mini-css-extract-plugin
module.exports = {"footer":"g7isD7","logo":"_2K5uhd","container":"_1RovDX","column":"_3u0P8G","withPaddingLeft":"_38bG6o"};